import React, { Component } from  'react';
import {
  Modal, Button
} from 'react-bootstrap'
class InfoModal extends Component {

  render() {
    return <Modal
      size="lg"
      show={this.props.modalShow}
      onHide={this.props.onHide}
      aria-labelledby="example-modal-sizes-title-lg"
      id="animViewModal"
      >
      <Modal.Header closeButton>
        <Modal.Title>About Gemini² Editor</Modal.Title>
      </Modal.Header>

      <Modal.Body>
        <p>This minimal editor is to show how Gemini² allows users to create animated transitions with keyframes.</p>
        <p>You can select an example from the dropdown list on the top and see how they are composed. </p>
        <p>The blue button with a bulb icon next to "Keyframe" provides automation features including keyframe recommendations and automation.</p>
        <p>Keyframe recommendation works for examples with two single-view Vega-Lite charts as start and end charts.</p>
        <p>More details of Gemini² are available on <a href="https://github.com/uwdata/gemini">this github repo</a>.</p>
        <p>Feel free to contact me about this project!</p>
        <p>Thanks!</p>
        <p>-Younghoon</p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" size="sm" onClick={this.props.onHide}>Close</Button>
      </Modal.Footer>
    </Modal>

  }


}

export default InfoModal;
